import React from 'react';
import DropdownMenu from './DropdownMenu';
//TODO Link completion tick to signoff button related to each phase
const WORKFLOW_STEPS = ['Designer Phase', 'Reviewer Phase', 'Amendments', 'Signoff'];

function getCompletedSteps(stage) {
  switch (stage) {
    case 'Designer Phase':
      return 0;
    case 'Ready For Review':
    case 'Reviewer Phase':
      return 1;
    case 'Amendments':
      return 2;
    case 'Ready For Signoff':
      return 3;
    case 'Signed Off':
      return 4;
    default:
      return 0;
  }
}

function WorkflowProgressBar({ activeStep, onStepChange, onHistoryClick, showHistory = true, currentReviewStage, onPrintReport }) {
  const activeIndex = WORKFLOW_STEPS.indexOf(activeStep);
  const completedSteps = currentReviewStage ? getCompletedSteps(currentReviewStage) : activeIndex;

  const isCompleted = (index) => index < completedSteps;
  const isActive = (index) => index === activeIndex;

  const renderStepIcon = (index) => {
    if (isCompleted(index)) {
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      );
    }
    return <span className="text-xs font-medium">{index + 1}</span>;
  };

  const renderConnector = (fromIndex, toIndex) => {
    const fromCompleted = isCompleted(fromIndex);
    const color = fromCompleted ? '#378ADD' : '#6B7280';
    
    return (
      <div 
        className="h-[1.5px] flex-1 min-w-[4px]"
        style={{ backgroundColor: color }}
      />
    );
  };

  return (
    <div className="w-full">
      {/* Step Bar */}
      <div className="flex items-center gap-2">
        <div className="flex items-center flex-1">
          {WORKFLOW_STEPS.map((step, index) => {
            const stepCompleted = isCompleted(index);
            const stepActive = isActive(index);
            
            return (
              <React.Fragment key={step}>
                <button
                  type="button"
                  onClick={() => onStepChange(step)}
                  className={`relative flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-full transition-all flex-shrink-0 ${
                    stepCompleted
                      ? 'bg-[var(--axial-primary-dark)] text-white border border-emerald-500/30'
                      : stepActive
                      ? 'bg-blue-600 text-white'
                      : 'bg-transparent text-gray-500 border border-gray-600/50 hover:border-gray-500'
                  }`}
                  style={{ borderWidth: '0.5px' }}
                >
                  <div className={`flex items-center justify-center w-5 h-5 rounded-full ${
                    stepCompleted
                      ? 'bg-emerald-500/20'
                      : stepActive
                      ? 'bg-white/20'
                      : 'bg-gray-700/50'
                  }`}>
                    {renderStepIcon(index)}
                  </div>
                  <span>{step}</span>
                </button>
                
                {index < WORKFLOW_STEPS.length - 1 && renderConnector(index, index + 1)}
              </React.Fragment>
            );
          })}
        </div>

        {/* Vertical Divider */}
        {showHistory && (
          <>
            <div className="w-px h-6 bg-gray-700 mx-1" />

            {/* History Button */}
            <button
              type="button"
              onClick={onHistoryClick}
              className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-full bg-transparent text-gray-400 border border-gray-600/50 hover:border-gray-500 hover:text-gray-300 transition-all"
              style={{ borderWidth: '0.5px' }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span>History</span>
            </button>

            {/* Action Button */}
            <DropdownMenu
              trigger={
                <button
                  type="button"
                  className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-full bg-transparent text-gray-400 border border-gray-600/50 hover:border-gray-500 hover:text-gray-300 transition-all"
                  style={{ borderWidth: '0.5px' }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="1"></circle>
                    <circle cx="12" cy="5" r="1"></circle>
                    <circle cx="12" cy="19" r="1"></circle>
                  </svg>
                </button>
              }
              items={[
                {
                  label: 'Print Report',
                  onClick: onPrintReport
                }
              ]}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default WorkflowProgressBar;
